<template>
    <b-form-row>
        <b-modal size="xl" ref="finder" hide-footer :id="this.id" :title="title">
            <StatusList :tipo="tipo" :prefix="updatedPrefix" :codEmpresa="codEmpresa"
                @onDblClickStatusSelect="statusSelect" />
        </b-modal>

        <lg-form-input-finder :value="computedValue" @input="updateValue" fieldDescription="descricao" :label="label"
            invalidFeedback="Status deve ser informado!" description="" @handleClean="handleClean">
            <template #prepend>
                <b-button @click="show" class="btn-input-finder" pressed>
                    <b-icon icon="search" />
                </b-button>
            </template>
        </lg-form-input-finder>
    </b-form-row>
</template>

<script>
import LgFormInputFinder from "@/core/components/Form/LgFormInputFinder.vue"
import StatusList from "../../modules/cadastros/status/StatusList.vue"

export default {
    components: { LgFormInputFinder, StatusList },
    props: {
        tipo: {
            type: Number,
            default: null
        },
        id: {
            type: String,
            default: "statusFinder"
        },
        prefix: Array,
        codEmpresa: Number,
        value: Object,
        label: {
            type: String,
            default: "Status:"
        }
    },
    data() {
        return {
            internalValue: this.value || {},
        };
    },
    watch: {
        value(newValue) {
            this.internalValue = newValue;
        },
    },
    computed: {
        computedValue: {
            get() {
                return this.internalValue;
            },
            set(newValue) {
                this.internalValue = newValue;
            },
        },
        updatedPrefix() {
            return [...this.prefix, "Status"].filter(item => item && item != "");
        },
        title() {
            return this.updatedPrefix.join(" > ");
        },
    },
    methods: {
        show() {
            this.$bvModal.show(this.id);
        },
        updateValue(newValue) {
            this.computedValue = newValue;
            this.$emit('input', newValue);
        },
        handleClean() {
            this.computedValue = {};
            this.$emit('input', {});
        },
        statusSelect(item) {
            this.computedValue = item;
            this.$emit('input', item);
            this.$bvModal.hide(this.id);
        },
    },
};
</script>
